// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Fc973","subheader":"ReorderModal_subheader__1jiRD","listWrap":"ReorderModal_listWrap__3sa8K"};